/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import OpportunityStageDropdown from 'domain/sales/opportunity/shared/input/OpportunityStageDropdown';
import { DefaultDropdownProps } from 'framework/form';

const OpportunityStageFilter = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <DropDownFilter {...props}>
      <OpportunityStageDropdown {...props} />
    </DropDownFilter>
  );
};

export default OpportunityStageFilter;
